import { DynamicForm } from '../../components/forms/DynamicForm';
import { PageHero } from '../../components/ui/PageHero';
import { Seo } from '../../components/ui/Seo';
import './Devis.css';

export function Devis() {
  return (
    <>
      <Seo
        title="Demander un devis gratuit — AXEO Services Cergy"
        description="Devis gratuit et sans engagement pour vos services à la personne ou vos prestations professionnelles à Cergy, Pontoise et dans toute la Communauté d'Agglomération de Cergy-Pontoise. Réponse sous 24h ouvrées."
        path="/devis"
      />

      <PageHero
        eyebrow="Devis gratuit"
        title="Demander un devis gratuit"
        subtitle="Décrivez votre besoin, nous revenons vers vous sous 24h ouvrées avec une proposition adaptée — que vous soyez un particulier ou un professionnel."
      />

      <section className="section devis-page">
        <div className="container devis-page__inner">
          <DynamicForm type="devis" />
        </div>
      </section>
    </>
  );
}
